import { render, staticRenderFns } from "./GenericPreview.vue?vue&type=template&id=3cab4c3c&scoped=true&"
import script from "./GenericPreview.vue?vue&type=script&lang=js&"
export * from "./GenericPreview.vue?vue&type=script&lang=js&"
import style0 from "./GenericPreview.vue?vue&type=style&index=0&id=3cab4c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cab4c3c",
  null
  
)

export default component.exports